
import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
//Mui Icons
import ListIcon from '@mui/icons-material/List';
//Mui
import { TextField, Grid } from '@mui/material';

import { columnsListReq } from './columnsListReq';
import { FilterSwitches } from "./FilterSwitches";
//Component
import CardTable from 'components/CardTable/CardTable.jsx';
import Snackbar from 'components/Snackbar/Snackbar';
import RegularButton from "components/CustomButtons/Button";

import { formatCustomDate } from "helpers/dateTools";
//Redux
import { clearSnackbar } from 'redux/actions/search/searchActions';
import { CUSTOMERS_TYPES } from 'redux/reducers/customers/customersTypes';
import {
  getAllItemsRequests,
  configFilterItemsRequests,
  configSortedItemsRequests,
  configPageItemsRequests,
  configPageItemsRequestsSize
} from 'redux/actions/integrations/itemsRequestActions';
import { getCategories } from 'redux/actions/categories/categoriesActions';
import { getClasses } from 'redux/actions/classes/classesActions';

import { ExpanderColumns } from './ExpanderColumns'

const style = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
};

export const ListRequest = () => {
  const { id } = useParams()
  const dispatch = useDispatch()
  const { isOpen, message, color, isLoading } = useSelector(({ search }) => search)
  const { itemsRequests, config } = useSelector(({ itemsRequests }) => itemsRequests)
  const { filtered, page, pageSize, sorted } = config;
  const { rules, id: idUser } = useSelector(({ login }) => login);
  const { categories } = useSelector(({ categories }) => categories);
  const { classes: allClasses } = useSelector(({ classes }) => classes);
  const [mapItemsRequests, setMapItemsRequests] = useState([])

  const currentDate = new Date();
  const maxDate = new Date();
  maxDate.setDate(currentDate.getDate());
  const maxDateString = maxDate.toISOString().split('T')[0];
  const [startDate, setStartDate] = useState(maxDateString)

  const handleFilter = useCallback((e) => {
    dispatch(configFilterItemsRequests(e));
  }, []);

  const handleSort = useCallback((e) => {
    dispatch(configSortedItemsRequests(e))
  }, [])

  const handlePageItemsRequests = useCallback((e) => {
    dispatch(configPageItemsRequests(e))
  }, [])

  const handlePageSize = useCallback((e) => {
    dispatch(configPageItemsRequestsSize(e))
  }, [])

  const handleCloseSnackbar = () => {
    dispatch(clearSnackbar())
  }

  const typeEsp = (type) => {
    return type === "UPDATE" ? "Actualizar" : "Crear"
  }

  const statusEsp = (status) => {
    return status === "PENDING" ? "Pendiente" : status === "APPROVED" ? "Aprobado" :
      status === "REJECTED" ? "Rechazado" : status === "IN ORACLE" ? "En Oracle" :
        status === "PARTIALLY IN ORACLE" ? "Parcialmente en Oracle" :
          status === "PARTIALLY IN APPROVED" ? "Parcialmente Aprobado" : "";
  }

  const handleStartDate = ({ target }) => {
    setStartDate(formatCustomDate(target.value, "-"))
  };

  const handleSubmit = () => {
    dispatch(getAllItemsRequests(idUser, startDate))
  }

  useEffect(() => {
    !id && dispatch({
      type: CUSTOMERS_TYPES.NEW_CUSTOMER_MODE,
      payload: true
    })
    if (rules.includes("INTEGRATIONS-ANALYST")) {
      dispatch(getAllItemsRequests())
    }
    else {
      dispatch(getAllItemsRequests(idUser))
    }
    dispatch(getCategories());
    dispatch(getClasses());
  }, [])

  useEffect(() => {
    setMapItemsRequests(itemsRequests.map((itemsRequest) => ({
      ...itemsRequest,
      dateCreate: formatCustomDate(itemsRequest.createdAt),
      userName: itemsRequest.user.userName,
      numberItem: Object.keys(itemsRequest?.items).length,
      typeEsp: typeEsp(itemsRequest?.type),
      statusEsp: statusEsp(itemsRequest?.status)
    })
    ))
  }, [itemsRequests])
  return (
    <>
      <CardTable
        columns={columnsListReq}
        data={mapItemsRequests}
        isLoading={isLoading}
        hasHeader
        icon={<ListIcon />}
        title="Lista de Solicitudes"
        titleBlock
        blockBtn
        filtered={filtered}
        page={page}
        sorted={sorted}
        pageSize={pageSize}
        onFilteredChange={handleFilter}
        onPageChange={handlePageItemsRequests}
        onSortedChange={handleSort}
        onPageSizeChange={handlePageSize}
        tableContent={
          <>
            <form
              onSubmit={handleSubmit}
              style={{
                width: "100%",
                padding: 4,
              }}
            >
              <Grid container spacing={1}>
                <Grid item xs={12} sm={3} style={style}>
                  <TextField
                    label="Desde"
                    type="date"
                    name="startDate"
                    value={startDate}
                    variant="outlined"
                    fullWidth
                    required={true}
                    onChange={handleStartDate}
                    size="small"
                    inputProps={{
                      max: maxDateString,
                    }}
                  />
                </Grid>
                <Grid
                  item xs={12} sm={1}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <RegularButton color="info" onClick={handleSubmit} fullWidth>
                    buscar
                  </RegularButton>
                </Grid>
              </Grid>
            </form>
            <FilterSwitches />
          </>
        }
        SubComponent={({ original }) => {
          return (
            <ExpanderColumns
              items={original.items}
              type={original.type}
              categories={categories}
              allClasses={allClasses}
            />
          )
        }}
      />
      <Snackbar
        open={isOpen}
        place="tr"
        message={message}
        color={color}
        closeNotification={handleCloseSnackbar}
        close
      />
    </>
  )
}
